export default {
  computed:{
    persistent(){
      return{
        'persistent' : this.isScrolling
      }
    }
  },
  data() {
    return {
      isScrolling: false
    }
  },
  methods: {
    setIsScrolling(value) {
      this.isScrolling = value;
    }
  }
}